<template>
  <div class="newsletter-banner-cta-container">
    <Toast ref="toast" />
    <div class="newsletter-banner-cta">
      <h1 class="newsletter-cta-text">
        Get tips to
        <span style="color: var(--primary-text-color);">upgrade your hiring process</span>
      </h1>
      <h2 class="secondary-text" style="color: var(--primary-text-color);">
        No fluff. Action takers only and SURPRISES 🎁
      </h2>
      <input
        class="input-container input-conatiner-medium"
        placeholder="Enter your email"
        ref="newsletterCTA"
        id="newsletterCTA"
        name="newsletterCTA"
        v-model="newsletterCTA"
        @click="select($refs.newsletterCTA, newsletterCTA)"
        type="text"
        @keyup.enter="subscribe(newsletterCTA)"
        maxlength="1000"
      />
      <button @click="subscribe(newsletterCTA)" class="tertiary-button" type="button">
        Send me tips
      </button>

      <p v-if="alreadyUsed" class="p-error">⚠️ Email already registered.</p>
      <p v-if="serverError" class="p-error">
        ⚠️ Server error, something went really bad. Try again or contanct my developers, they forgot some code.
      </p>
      <p v-if="showEmailBadFormat" class="p-error">
        ⚠️ Email not looking correct, try with the following format: name@domain.com
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import * as validator from "email-validator";
import Toast from "@/components/Toast";

export default {
  components: {
    Toast,
  },

  data() {
    return {
      newsletterCTA: "",
      showEmailBadFormat: false,
      serverError: false,
      alreadyUsed: false,
    };
  },

  methods: {
    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },

    async subscribe(email) {
      this.serverError = false;
      this.showEmailBadFormat = false;
      this.alreadyUsed = false;

      if (!validator.validate(email)) {
        this.showEmailBadFormat = true;
        this.newsletterCTA = "";
        return;
      }

      try {
        const jobboardyList = "19f999d3-844e-11eb-a3d0-06b4694bee2a";
        await firebase.functions.httpsCallable("addSubscriber")({
          email,
          list: jobboardyList,
        });
        this.newsletterCTA = "";

        this.$refs.toast.text = "We will send you an email when we are ready to launch.";
        this.$refs.toast.show();
      } catch (error) {
        if (error.code === "aborted") {
          this.alreadyUsed = true;
          this.newsletterCTA = "";
          return;
        }
        this.newsletterCTA = "";
        this.serverError = true;
        console.error(error);
      }
    },
  },
};
</script>
>

<style></style>
